<template>
    <div class="pl-lg-4">
        <div class="row">
            <div class="col-lg-2">
                <base-input alternative="">
                    <select
                        class="form-control form-control-alternative"
                        v-model="page"
                        @change="getPageItems()"
                        :disabled="isLoadingBlade"
                    >
                        <option
                            v-for="(number, index) in visiblePages"
                            :key="index"
                            :value="number"
                        >
                            {{ number }}
                        </option>
                    </select>
                </base-input>
            </div>
            <div class="col-lg-8"></div>
            <div class="col-lg-2">
                <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fas fa-filter"></i> </span>
                    </div>
                    <select
                        class="form-control"
                        v-model="year"
                        @change="loadCertificates()"
                        :disabled="isLoadingBlade"
                    >
                        <option v-for="(year, index) in years" :key="index" :value="year">
                            {{ year }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-lg-12" v-if="isLoadingBlade">
                <div class="d-flex justify-content-center">
                    <img :src="loadingBladeUrl" />
                </div>
            </div>

            <div class="col-lg-12" v-if="! isLoadingBlade">
                <h4 class="text-uppercase text-center height-50">
                    Your 
                    <strong class="text-danger">
                        {{ this.year }}
                    </strong>
                     WCEA Certificates 
                </h4>
                <div class="alert alert-warning alert-dismissible fade show text-center" role="alert">
                    <span class="alert-inner--icon"><i class="fas fa-info-circle"></i></span>
                    <span class="alert-inner--text text-uppercase">
                        <strong> Note:</strong> Please click on each certificate’s 
                        <span class="badge badge-primary">Update Point</span> 
                        button to update your CPD points and meet the license renewal criteria.
                    </span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <hr>
            </div>

            <div class="col-lg-12" v-if="! isLoadingBlade">
                <div class="card shadow">
                    <div class="table-responsive">
                        <base-table
                            class="table align-items-center table-flush"
                            thead-classes="thead-light"
                            tbody-classes="list"
                            :data="records"
                            v-if="records && records.length > 0"
                        >
                            <template slot="columns">
                                <th width="2%">S/N</th>
                                <th width="20%">Course Title</th>
                                <th width="30%">Educator Name</th>
                                <th width="20%">CPD Points</th>
                                <th width="20%">Completion Date</th>
                                <th width="8%">&nbsp;</th>
                            </template>

                            <template
                                slot-scope="{row, index}"
                            >
                            <td class="budget">
                                {{ pagination.from+index}}
                            </td>
                            <td class="text-capitalize">
                                <span v-html="breakword(row.tr_name)"></span>
                            </td>
                            <td>
                                <span v-html="breakword(row.educator_name)"></span>
                            </td>
                            <td>
                                {{ row.cpd_hours ? row.cpd_hours : 'N/A' }}
                            </td>
                            <td>
                                {{ row.date_completion | getDateFormat }}
                            </td>
                            <td>
                                <a
                                    :href="row.certificate_image_file_url"
                                    class="btn btn-sm btn-primary"
                                    target="_blank"
                                    v-if="row.certificate_image_file_url"
                                >
                                    <i class="fa fa-download"></i> Download
                                </a>

                                <base-button
                                    type="info"
                                    class="btn btn-sm btn-info"
                                    @click="updateCpdPoints(row)"
                                    v-if="! row.user_cpd_point"
                                >
                                    <i class="fa fa-history"></i> 
                                    {{ isloading ? 'Please Wait' : 'Update Point' }}
                                </base-button>
                                
                                <badge 
                                    type="warning"
                                    class="btn btn-sm btn-warning"
                                    v-if="row.user_cpd_point"
                                >
                                    Updated
                                </badge>
                            </td>

                            </template>

                        </base-table>
                    </div>

                    <div
                        class="card-footer d-flex justify-content-end bg-transparent"
                        v-if="hasPagination"
                        @click="paginate"
                    >
                        <base-pagination
                            :total="pagination.total"
                            align="center"
                            v-model="pagination.number"
                            :perPage="pagination.perPage"

                        >
                        </base-pagination>
                    </div>

                </div>
            </div>

            <div class="col-sm-12 text-center" v-if='showErrorStatus'>
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'WceaCertificates',
        data() {
            return {
                records: [],
                paginatedItems: [],
                pagination: {
                    total: null,
                    prev_page_url: null,
                    next_page_url: null,
                    current_page: null,
                    last_page: null,
                    number: 1,
                    from: 0,
                    to: null,
                    perPage: this.$store.state.user.perPage // get per page count
                },
                page: 1,
                year: new Date().getFullYear(),
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false,
                isLoadingBlade: true
            }
        },
        filters: {
            getDateFormat(value) {
                if (value) {
                    return moment(value).format('Do MMM, YYYY');
                } else {
                    return 'N/A';
                }
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl', 'visiblePages']),
            hasPagination() {
                return this.pagination.next_page_url || this.pagination.prev_page_url;
            },
            years() {
                let startYear = this.$store.state.user.wceaStartYear;
                let endYear = new Date().getFullYear(); 
                let years = [];
                for (let i = startYear; i <= endYear; i++) {
                    years.push(i);
                }
                return years;
            },
            wceaParams() {// WCEA Platform params
                return {
                    start_date  : this.year + '-01-01',
                    end_date    : this.year + '-12-31',
                    offset      : 0
                };
            }
        },
        methods: {
            ...mapActions(['getWceaCertificates', 'getPaginatedApplicationItems', 'updateDoctorCpdPoints', 'fetchNewPageData']),
            breakword(text, length = 4) {
                if(text) {
                    let splitted = text.split(' ');
                    let halfPoint = Math.ceil(splitted.length / 2);
                    let word = '';
                    for (let index = 0; index < splitted.length; index++) {
                        if((index == halfPoint) && (index >= length)) {
                            word += '<br> ' + splitted[index];
                        } else {
                            word += ' ' + splitted[index];
                        }
                    }
                    return word;
                } else {
                    return 'N/A';
                }
            },
            loadCertificates() {
                this.preloader();// show loading
                this.isloading = true;
                this.showErrorStatus = false;
                let data = { 
                    offset : this.wceaParams.offset, 
                    start_date : this.wceaParams.start_date, 
                    end_date : this.wceaParams.end_date, 
                    limit : this.pagination.perPage 
                };
                this.getWceaCertificates(data).then((res) => {// get applications
                    swal.close();
                    if(res.status) {
                        this.setPages(res.items);// set pagination
                    }                    
                    this.isLoadingBlade = false;
                    this.isloading = false;
                    this.emptyRecordsMsg();//show empty msg
                }).
                catch(() => {
                    this.isLoadingBlade = false;
                    this.isloading = false;
                    this.showErrorStatus = true;
                    this.errorMsg = "Server Failure!", "Kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            setPages(res) {// set paginated function
                this.records = [];
                this.paginatedItems = res.data;
                this.records = this.paginatedItems;
                this.pagination.from = res.from;
                this.pagination.to = res.to;
                this.pagination.total = res.total;
                this.pagination.current_page = res.current_page;
                this.pagination.last_page = res.last_page;
                this.pagination.prev_page_url = res.prev_page_url;
                this.pagination.next_page_url = res.next_page_url;
                this.fetchNewPageData({// handle pagination numbers
                    current_page : res.current_page,
                    last_page : res.last_page
                });
                this.isLoadingBlade = false;
                this.emptyRecordsMsg();//show empty msg
            },
            getPageItems() {
                let newUrl = '';
                let url = this.pagination.next_page_url ?
                            this.pagination.next_page_url : this.pagination.prev_page_url;
                let exploded = url.split('&');
                exploded.pop();// remove the page item
                for(let item of exploded) { newUrl += item +'&'; }// create url from exploded url
                newUrl += 'page='+this.page;// add new page item
                this.isLoadingBlade = true
                this.getPaginatedApplicationItems(newUrl).then((res) => {// get records
                    this.pagination.number = res.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            paginate() {// paginate function
                this.showErrorStatus = false;
                let url = (this.pagination.number > this.pagination.current_page) ?
                    this.pagination.next_page_url : this.pagination.prev_page_url;
                if(url) {// make api call
                    this.isLoadingBlade = true
                    this.getPaginatedApplicationItems(url).then((res) => {// get users
                        this.pagination.number = res.current_page;
                        this.setPages(res);
                    }).
                    catch(() => {
                        this.records = [];
                        this.showErrorStatus = true;
                        this.isLoadingBlade = false;
                        this.errorMsg = "Network Failure!, Kindly reload the page...";
                        this.errorType = 'danger';
                    });
                } else {
                    this.records = this.paginatedItems;
                }
            },
            emptyRecordsMsg() {
                return this.records && this.records.length == 0
                    ? this.showEmptyMsg() : false;
            },
            showEmptyMsg() {// show empty msg
                this.showErrorStatus = true;
                this.errorType = 'warning';
                this.errorMsg = 'No Certificates for the Year '+ this.year + ' !, kindly complete a course on WCEA platform';
            },
            updateCpdPoints(row) {// update CPD points
                if(row.certificate_id && row.cpd_hours) {// get rrr status
                    const year = row.date_completion ? new Date(row.date_completion).getFullYear() : new Date().getFullYear();
                    let data = {
                        'certificate_id'    :   row.certificate_id,
                        'name'              :   row.tr_name,
                        'point'             :   row.cpd_hours,
                        'license_year'      :   (year + 1),
                        'file_url'          :   row.certificate_image_file_url,
                        'date'              :   row.date_completion
                    };
                    this.preloader();// show loading
                    this.updateDoctorCpdPoints(data).then((res) => {
                        if(res.status) {// update transaction
                            this.loadCertificates();
                            swal.fire("Updated Successfully!",res.msg , "success");
                        } else {
                            swal.fire("Updated Failed!",res.msg , "warning");
                        }
                    }).
                    catch(() => {
                        swal.fire("Server Failure!", "Kindly reload the page...", "warning");
                    });
                } else {
                    swal.fire("Updated Failed!", "CPD Point was not updated, invalid Certifcate ID or CPD Points", "warning");
                }
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait!',
                    html: 'Trying to fetch data from <b>server</b> ...',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        mounted() {
            this.loadCertificates();// load applications
        },
    }
</script>
<style scoped>
    .filter-select {
        padding-left: 35px !important;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%238898aa' d='M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.053 25.861 509.282 0 487.976 0z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: left 12px center;
        background-size: 14px;
    }
</style>